import {styled} from '@esgi/ui/theme';
import {animated} from 'react-spring';

export const StyledImage = styled(animated.img, {
	width: '100%',
	height: '100%',
	objectFit: 'cover',
});